import { IStoragePermissions } from "@/types/Storage.types";

export const StoragePermissions: IStoragePermissions = {
  shelfLifeInformation: {
    primaryShelfLifeCodingFromDateOf: {
      isEditable: true,
      isMandatory: true,
    },
    period: {
      isEditable: true,
      isMandatory: true,
    },
    formatOfShelfLifeCoding: {
      isEditable: true,
      isMandatory: true,
    },
    bestByDateImprintRequired: {
      isEditable: true,
      isMandatory: true,
    },
    primaryShelfLife: {
      isEditable: true,
      isMandatory: true,
    },
    secondaryShelfLife: {
      isEditable: true,
      isMandatory: false,
    },
    minimumShelfLifeInfo: {
      isEditable: true,
      isMandatory: true,
    },
  },
  outerCaseInformation: {
    primaryOuterCase: {
      isEditable: true,
      isMandatory: true,
    },
    secondaryOuterCase: {
      isEditable: true,
      isMandatory: false,
    },
    primaryNumber: {
      isEditable: true,
      isMandatory: true,
    },
    secondaryNumber: {
      isEditable: true,
      isMandatory: false,
    },
  },
  lotCodeInformation: {
    days: {
      isEditable: true,
      isMandatory: true,
    },
    defineEntireLotCodeInformation: {
      isEditable: true,
      isMandatory: true,
    },
    comments: {
      isEditable: true,
      isMandatory: false,
    },
  },
};
